module.exports = __webpack_public_path__ + "static/media/17_2.f971a347.jpg";